async function UrlToBase(url: string) {
  try {
    // Determine the image type from the URL
    const imageType = url.split('.').pop();
    if (!imageType) throw new Error('Failed to determine image type from URL');
    const mimeType = `image/${imageType}`;

    // Fetch the image from the URL
    const response = await fetch(url);
    if (!response.ok)
      throw new Error(`Failed to fetch image (HTTP status ${response.status})`);

    // Convert the image data to a Blob
    const blob = await response.blob();

    // Read the Blob as a Base64 string with the specified MIME type
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result?.toString().split(',')[1];
        if (!base64String) reject(new Error('Failed to read image data'));
        resolve(`data:${mimeType};base64,${base64String}`);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Failed to convert URL to Base64:', error);
    return null;
  }
}

export { UrlToBase };
